import React, { useEffect, useState } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Table, Button, Tag, Card, Space } from 'antd';
import 'antd/dist/antd.css';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Storage } from 'react-jhipster';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getSession } from 'app/shared/reducers/authentication';
import { APP_LOCAL_DATE_FORMAT, AUTHORITIES } from 'app/config/constants';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { getEcoleAnneeScolaire } from './annee-scolaire.reducer';
import { StatusAnneeScolaire } from 'app/shared/model/anneeScolaire.model';
import { getEcole } from '../ecole/ecole.reducer';
import { EditOutlined, DeleteOutlined, PlayCircleOutlined, LockOutlined } from '@ant-design/icons';
import { ConfirmStartAnneeScolaireModal } from './ConfirmStartAnneeScolaireModal';

export const AnneeScolaires = (props: RouteComponentProps<{ ecoleid: string }>) => {
  const dispatch = useAppDispatch();
  const anneeScolaireList = useAppSelector(state => state.anneeScolaire.entities);
  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN]));

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [anneeScolaireIdToStart, setAnneeScolaireIdToStart] = useState<string | null>(null);

  const setcurrentannee = annee => {
    Storage.session.set('currentAnneeScolaire', annee);
  };

  useEffect(() => {
    dispatch(getSession());
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getEcoleAnneeScolaire(props.match.params.ecoleid));
  }, []);

  const showConfirmModal = (id: string) => {
    setAnneeScolaireIdToStart(id);
    setIsModalVisible(true);
  };

  const handleConfirm = () => {
    setIsModalVisible(false);
    setAnneeScolaireIdToStart(null);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setAnneeScolaireIdToStart(null);
  };

  const columns = [
    {
      title: 'Nom',
      dataIndex: 'nom',
      key: 'nom',
      render: (text, row) => (
        <Link onClick={() => setcurrentannee(row)} to={`/home/${currentEcole && currentEcole.id}/${row['id']}`}>
          {row['nom']}
        </Link>
      ),
    },
    {
      title: 'Date de debut',
      dataIndex: 'dateDebut',
      key: 'dateDebut',
      render: date => date && <TextFormat type="date" value={date} format={APP_LOCAL_DATE_FORMAT} />,
    },
    {
      title: 'Date de Cloture',
      dataIndex: 'dateFin',
      key: 'dateFin',
      render: dateFin => (dateFin !== null ? <TextFormat type="date" value={dateFin} format={APP_LOCAL_DATE_FORMAT} /> : ' '),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: status => (status === StatusAnneeScolaire.ACTIVE ? <Tag color="green">{status}</Tag> : <Tag color="red">{status}</Tag>),
    },
    {
      title: 'Option',
      dataIndex: 'option',
      key: 'option',
      render: (id, row) => (
        <Space size="large">
          {isAdmin && row.status !== StatusAnneeScolaire.CLOTUREE && (
            <>
              {row.status !== StatusAnneeScolaire.ACTIVE && (
                <Button
                  onClick={() => showConfirmModal(id)}
                  type="text"
                  icon={<PlayCircleOutlined />}
                  size={'large'}
                  style={{ color: '#6fd639' }}
                />
              )}
              <Button onClick={e => handleUpdate(id)} type="text" style={{ color: '#2f54eb' }} icon={<EditOutlined />} size={'middle'} />
              <Button onClick={e => handleDelete(id)} type="text" danger icon={<DeleteOutlined />} size={'middle'} />
              {row.status !== StatusAnneeScolaire.INACTIVE && (
                <Button onClick={e => handleCloture(id)} type="text" style={{ color: 'black' }} icon={<LockOutlined />} size={'middle'} />
              )}
            </>
          )}
        </Space>
      ),
    },
  ];

  const { match } = props;
  const dataSource = anneeScolaireList.map((anneeScolaire, i) => ({
    id: anneeScolaire.id,
    status: anneeScolaire.statutAnneeScolaire,
    nom: anneeScolaire.nom,
    dateDebut: anneeScolaire.dateDebut,
    dateFin: anneeScolaire.dateCloture,
    option: anneeScolaire.id,
  }));

  const handleModal = () => {
    props.history.push(`/annee-scolaire/${currentEcole.id}/new`);
  };

  const handleUpdate = (value: string) => {
    const id = value;
    id && props.history.push(`/annee-scolaire/${currentEcole.id}/${id}/edit`);
  };

  const handleDelete = (value: string) => {
    const id = value;
    id && props.history.push(`/annee-scolaire/${currentEcole.id}/${id}/delete`);
  };

  const currentEcole = useAppSelector(state => state.ecole.entity);

  const handleCloture = value => {
    const id = value;
    id && props.history.push(`/annee-scolaire/${currentEcole.id}/${id}/cloture`);
  };
  return (
    <div>
      <h2 id="ecole-heading" data-cy="EcoleHeading">
        <Translate contentKey="korischoolApp.anneeScolaire.home.title">Années Scolaires</Translate>
      </h2>
      <Card>
        {isAdmin && (
          <div style={{ textAlign: 'right' }}>
            <Button
              onClick={handleModal}
              className="btn jh-create-entity"
              id="jh-create-entity"
              style={{ backgroundColor: '#F28E19', color: 'white' }}
              data-cy="entityCreateButton"
            >
              <FontAwesomeIcon icon="plus" />
              &nbsp;
              <Translate contentKey="korischoolApp.anneeScolaire.home.createLabel">Create new Annee Scolaire</Translate>
            </Button>
          </div>
        )}
        <div className="table-responsive mt-2">
          <Table dataSource={dataSource.reverse()} columns={columns} pagination={false} />
        </div>
      </Card>
      <ConfirmStartAnneeScolaireModal
        visible={isModalVisible}
        anneeScolaireId={anneeScolaireIdToStart}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </div>
  );
};

export default AnneeScolaires;
